<lxm-button icon="minus-small" type="transparent" (click)="decZoom()"></lxm-button>
<span class="zoom-value">
    {{formatValue(value)}}%
</span>
<lxm-button icon="plus-small" type="transparent" (click)="addZoom()"></lxm-button>